@if (featureOptimizationEnabled()) {
    <div class="flex-col gap-24">
        <div class="flex-col gap-8" [formGroup]="offerNoteForm">
            @if (shouldDisplayNoteCategoryCheckbox) {
                <div class="flex-row gap-4 items-center">
                    <label class="note-type-radio-label">To:</label>
                    <mat-radio-group formControlName="noteCategory">
                        <mat-radio-button
                            [value]="2"
                            data-qa-id="radio-button-AM"
                        >Recruiter</mat-radio-button>
                        <mat-radio-button
                            [value]="1"
                            class="ml-3"
                            data-qa-id="radio-button-client"
                        >Client</mat-radio-button>
                    </mat-radio-group>
                </div>
            }
            <mat-form-field>
                <textarea matInput class="note-textarea" data-qa-id="an_shared_notes_textarea" formControlName="noteText"></textarea>
                <mat-hint class="note-textarea-hint" align="end"> {{ offerNoteForm.get('noteText')?.value.length || 0 }}/500</mat-hint>
            </mat-form-field>
            <div>
                <button mat-flat-button color="primary" [disabled]="isDisabled" (click)="addNote()" data-qa-id="an_shared_notes_send_note">
                    Send Note
                </button>
            </div>
        </div>
        <div class="notes-filter flex-row items-center gap-12"> <span>Show:</span>
            <mat-chip-listbox multiple aria-label="deals type filter" [formControl]="selectedNoteSourceFilter" class="flex-row gap-8">
                <mat-chip-option [value]="1">Deal Notes</mat-chip-option>
                <mat-chip-option [value]="2">Submittal Notes</mat-chip-option>
            </mat-chip-listbox>
        </div>

        <div [hidden]="!scrollMe">
            <div #scrollMe class="notes-container-new flex-col gap-24">
                @for (note of filteredNotes; track note; let last = $last) {
                    <div class="flex-col gap-24">
                        <div class="flex-col gap-8">
                            <div data-qa-id="an_offer_note_header" class="flex-row space-between">
                                @if (!shouldUseImpersonationUi()) {
                                    <div class="flex-row gap-4">
                                        <span class="note-fullname">{{ note.fullName }}</span>
                                        @if (note.description) {
                                            <span class="note-description">({{ note.description }})</span>
                                        }
                                        @if (shouldDisplayCategoryChips(note)) {
                                            <span class="color-neutral-700">{{note.category}}</span>
                                        }
                                    </div>
                                } @else {
                                    <div class="flex-col gap-4">
                                        <div class="flex-row gap-2 items-center">
                                            <span class="note-fullname">{{ note.fullName }}</span>

                                            @if (note.description) {
                                                <span class="note-description ml-1">({{ note.description }})</span>
                                            }

                                            @if (shouldShowImpersonationMask(note)) {
                                                <mat-icon
                                                    class="impersonation-mask-icon material-symbols-outlined ml-1"
                                                    [matTooltip]="getImpersonationTooltip(note)"
                                                    matTooltipPosition="below"
                                                    data-qa-id="offer-note-impersonation-view"
                                                    aria-label="Impersonation indicator">
                                                    domino_mask
                                                </mat-icon>
                                            }
                                        </div>

                                        @if (shouldDisplayCategoryChips(note)) {
                                            <div>
                                                <mat-chip data-qa-id="an_offer_note_category_chip" class="note-category-chip">
                                                    {{ note.category }}
                                                </mat-chip>
                                            </div>
                                        }
                                    </div>
                                }
                                <div class="timestamp">{{ note.createdDate | date: 'MM/dd/yyyy hh:mm a'}}</div>
                            </div>
                            @if (note.candidateOfferChangeNote) {
                                <div class="offer-change-grid flex-col gap-4">
                                    @if (note.candidateOfferChangeNote?.isFromSnapshot) {
                                        <div class="offer-change-grid-header flex-row gap-38">
                                            <div class="label"></div>
                                            <div class="flex-row gap-24">
                                                <div class="from color-neutral-700">Recruiter Submittal</div>
                                                <div class="to color-neutral-700">Updated Offer</div>
                                            </div>
                                        </div>
                                    } @else {
                                        <div class="offer-change-grid-header flex-row gap-38">
                                            <div class="label"></div>
                                            <div class="flex-row gap-24">
                                                <div class="from color-neutral-700">From</div>
                                                <div class="to color-neutral-700">To</div>
                                            </div>
                                        </div>
                                    }
                                    <div class="flex-col gap-16">
                                        @for (change of note.candidateOfferChangeNote?.changeData; track change) {
                                            <div class="offer-change-grid-row flex-row gap-38">
                                                <div class="label color-neutral-700">{{ change.property }}</div>
                                                <div class="flex-row gap-24">
                                                    @if (change.property === 'RTO') {
                                                        <div class="from">
                                                            @for (date of RtoDatesHelpers.convertRTODateStringToStringArray(change.valueFrom); track date; let isLast = $last) {
                                                                <span>{{date}}</span>
                                                                @if (!isLast) {
                                                                    <span>,</span>
                                                                }
                                                                <br />
                                                            }
                                                        </div>
                                                        <div class="to">
                                                            @for (date of RtoDatesHelpers.convertRTODateStringToStringArray(change.valueTo); track date; let isLast = $last) {
                                                                <span>{{date}}</span>
                                                                @if (!isLast) {
                                                                    <span>,</span>
                                                                }
                                                                <br />
                                                            }
                                                        </div>
                                                    } @else {
                                                        <div class="from">{{ change.valueFrom }}</div>
                                                        <div class="to">{{ change.valueTo }}</div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="flex-row gap-8">
                                @if (note.title) {
                                    <span class="note-title">{{ note.title }}</span>
                                }
                                <span class="note" [innerHtml]="note.note"></span>
                            </div>
                            @if (note.source && showNoteSourceTypePill) {
                                <div>
                                    @switch (note.source) {
                                        @case (CandidateOfferNoteSourceEnum.Offer) {
                                            <mat-chip data-qa-id="an_offer_note_source_chip" class="note-source-chip">Deal Note</mat-chip>
                                        }
                                        @case (CandidateOfferNoteSourceEnum.Submittal) {
                                            <mat-chip data-qa-id="an_offer_note_source_chip" class="note-source-chip">Submittal Note</mat-chip>
                                        }
                                    }
                                </div>
                            }
                        </div>
                        @if (!last){
                            <mat-divider></mat-divider>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    <div class="header flex-row space-between items-center">
        <div class="label-text">{{ headingTitle }}</div>
        <div class="desc">{{ headingTitleSubtext }}</div>
    </div>

    <div [hidden]="!scrollMe">
        <div #scrollMe class="notes-container">
            <div class="notes-item" *ngFor="let note of agencyNotes">
                <div data-qa-id="an_offer_note_header" class="notes-item-header flex-row space-between items-center">
                    <ng-container *ngIf="!shouldUseImpersonationUi()">
                        <ng-container *ngIf="!shouldDisplayCategoryChips(note)">
                            <div class="user">{{ note.fullName }} ({{ note.description }}) {{ note.title ? '- ' + note.title : '' }}</div>
                        </ng-container>
                        <ng-container *ngIf="shouldDisplayCategoryChips(note)">
                            <div class="user flex-row-wrap items-baseline gap-8">{{ note.fullName }} ({{ note.description }})<ng-container *ngIf="note.category"><mat-chip data-qa-id="an_offer_note_category_chip" class="note-category-chip">{{note.category}}</mat-chip></ng-container></div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="shouldUseImpersonationUi()">
                        <ng-container *ngIf="!shouldDisplayCategoryChips(note)">
                            <div class="flex-row gap-4 items-center">
                                <div class="user">{{ note.fullName }} ({{ note.description }}) {{ note.title ? '- ' + note.title : '' }}</div>
                                @if (shouldShowImpersonationMask(note)) {
                                    <mat-icon
                                        class="impersonation-mask-icon material-symbols-outlined"
                                        [matTooltip]="getImpersonationTooltip(note)"
                                        matTooltipPosition="below"
                                        data-qa-id="offer-note-impersonation-view"
                                        aria-label="Impersonation indicator">
                                        domino_mask
                                    </mat-icon>
                                }
                            </div>
                            <ng-container *ngIf="note.category">
                                <mat-chip data-qa-id="an_offer_note_category_chip" class="note-category-chip">{{ note.category }}</mat-chip>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="shouldDisplayCategoryChips(note)">
                            <div class="user flex-row-wrap items-baseline gap-8">
                                <span>{{ note.fullName }} ({{ note.description }})</span>
                                @if (shouldShowImpersonationMask(note)) {
                                    <mat-icon
                                        class="impersonation-mask-icon material-symbols-outlined"
                                        [matTooltip]="getImpersonationTooltip(note)"
                                        matTooltipPosition="below"
                                        data-qa-id="offer-note-impersonation-view"
                                        aria-label="Impersonation indicator">
                                        domino_mask
                                    </mat-icon>
                                }
                            </div>
                            <ng-container *ngIf="note.category">
                                <mat-chip data-qa-id="an_offer_note_category_chip" class="note-category-chip">{{note.category}}</mat-chip>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <div class="timestamp">{{ note.createdDate | date: 'MM/dd/yyyy hh:mm:ss a'}}</div>
                </div>
                <ng-container *ngIf="shouldDisplayTitleOnNewLine(note)">
                    <div data-qa-id="an_offer_note_title_new_line" class="notes-title">
                        {{note.title}}
                    </div>
                </ng-container>
                <div data-qa-id="an_offer_note_body" class="notes-body">
                    <p class="note" [innerHtml]="note.note"></p>
                </div>
            </div>
        </div>
    </div>

    <div class="note-input">
        <ng-content select="[noteInput]"></ng-content>
    </div>
}
